export default "__VITE_ASSET__CHLrpQP___"